import { z } from 'zod'

/**
 * O relato de erro do navegador (ADR 0035 secao 7). docs/03-arquitetura.md secao 6.
 *
 * Mora no contrato porque os dois lados precisam dele: o `web2` monta o relato e o `api` o recebe.
 * Tipado de um lado so, o teto de um e o corte do outro divergiriam na primeira mudanca.
 *
 * **O schema trunca, e nao recusa.** Uma pilha de 20 KB e um erro de verdade, e recusar o relato
 * por excesso perderia justamente o erro mais estranho. O que se recusa e o que nao e relato: tipo
 * desconhecido, campo que nao e texto.
 */

/** De onde o erro veio: o *error boundary* do React, o `error` da janela ou a promessa sem tratamento. */
export const CLIENT_ERROR_KINDS = ['boundary', 'error', 'unhandledrejection'] as const

export type ClientErrorKind = (typeof CLIENT_ERROR_KINDS)[number]

/**
 * Os tetos, em caracteres. A mensagem e o que se le no painel; a pilha e o que se le na
 * investigacao, e 4 000 caracteres cobrem as primeiras dezenas de quadros, que e onde o erro esta.
 */
export const CLIENT_ERROR_MESSAGE_MAX = 500
export const CLIENT_ERROR_STACK_MAX = 4000
export const CLIENT_ERROR_PATH_MAX = 300
export const CLIENT_ERROR_RELEASE_MAX = 64

/**
 * Quantos relatos um carregamento de pagina envia, no maximo. Um erro dentro de um laco de
 * renderizacao dispararia centenas por segundo; o primeiro punhado ja diz tudo.
 */
export const CLIENT_ERROR_MAX_PER_PAGE = 5

/**
 * O caminho, sem query string nem fragmento. E ali que mora o que nao pode ir para o log: o
 * `?code=` do retorno do OAuth, o `#token` de um link.
 */
export const pathWithoutQuery = (path: string): string =>
  (path.split(/[?#]/, 1)[0] ?? '').slice(0, CLIENT_ERROR_PATH_MAX)

const truncated = (max: number) => z.string().transform((text) => text.slice(0, max))

export const clientErrorReportSchema = z.object({
  kind: z.enum(CLIENT_ERROR_KINDS),
  message: truncated(CLIENT_ERROR_MESSAGE_MAX),
  stack: truncated(CLIENT_ERROR_STACK_MAX).optional(),
  path: z.string().transform(pathWithoutQuery),
  /** A versao do cliente que relatou, quando o build a conhece. */
  release: truncated(CLIENT_ERROR_RELEASE_MAX).optional(),
})

export type ClientErrorReport = z.input<typeof clientErrorReportSchema>
